import { redirect } from "@tanstack/react-router";
import { AuthConfig, useAuthStore } from "@theprelude/core";
import { shallow } from "zustand/shallow";

export type Auth = {
  getAuthConfig: () => Promise<AuthConfig>;
  signOut: (params?: { clearAccount?: boolean }) => Promise<void>;
  changeAccount: (account: string) => void;
};

export const useAuth = (): Auth => {
  const getAuthConfig = useAuthStore((state) => state.getAuthConfig, shallow);
  const signOut = useAuthStore((state) => state.signOut, shallow);
  const changeAccount = useAuthStore((state) => state.changeAccount, shallow);

  return {
    signOut,
    changeAccount,
    getAuthConfig,
  };
};

export async function ensureAuth(auth: Auth) {
  const config = await auth.getAuthConfig();

  if (config.status !== "authenticated") {
    throw redirect({ to: "/sign-in", search: { redirect: location.href } });
  }

  return config;
}
